import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Loader } from "@components/atoms";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as appPaths from "../../../../app/routes";
import { OverlayContext } from "../../../../components/Overlay";
import logoMobile from "../../../../images/logo-mobile.svg";
import logoImg from "../../../../images/logo.svg";
import * as S from "./styles";

// import { Container } from "../Container";

/**
 * Template for checkout page.
 */
var Checkout = function Checkout(_ref) {
  var loading = _ref.loading,
      navigation = _ref.navigation,
      checkout = _ref.checkout,
      cartSummary = _ref.cartSummary,
      button = _ref.button;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileCartOpened = _useState2[0],
      setMobileCartOpened = _useState2[1];

  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement(S.Container, null, React.createElement(S.Logo, null, React.createElement(Link, {
      to: appPaths.baseUrl,
      className: "main-menu__logo main-menu__logo-checkout"
    }, React.createElement("img", {
      src: logoImg,
      alt: "Reno"
    }), React.createElement("img", {
      src: logoMobile,
      alt: "Reno",
      className: "main-menu__logo-mobile"
    }))), loading && React.createElement(S.Loader, null, React.createElement(Loader, {
      fullScreen: true
    })), React.createElement(S.Wrapper, {
      mobileCartOpened: mobileCartOpened
    }, React.createElement(S.WrapperColLeft, {
      mobileCartOpened: mobileCartOpened
    }, React.createElement(S.Navigation, null, navigation), React.createElement(S.Checkout, {
      mobileCartOpened: mobileCartOpened
    }, checkout), React.createElement(S.Button, null, button)), React.createElement(S.WrapperColRight, {
      mobileCartOpened: mobileCartOpened
    }, React.createElement(S.CartSummary, null, cartSummary && cartSummary(mobileCartOpened, setMobileCartOpened, overlayContext)))));
  });
};

export { Checkout };